import { AppIcon } from '@/components/ui/app-icon';
import { iconLinkedin } from '@/lib/icons';
import { cn } from '@/lib/utils';
import { providerLabel } from './provider.util';

// Real multicolour brand marks. The icon set only has monochrome glyphs, so
// the recognisable Google and Microsoft logos are inlined as SVGs.
export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 48 48' className={className} aria-hidden='true'>
      <path
        fill='#4285F4'
        d='M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z'
      />
      <path
        fill='#34A853'
        d='M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z'
      />
      <path
        fill='#FBBC05'
        d='M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z'
      />
      <path
        fill='#EA4335'
        d='M24 9.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 3.18 29.93 1 24 1 15.4 1 7.96 5.93 4.34 13.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z'
      />
    </svg>
  );
}

export function MicrosoftIcon({ className }: { className?: string }) {
  return (
    <svg viewBox='0 0 23 23' className={className} aria-hidden='true'>
      <path fill='#f25022' d='M1 1h10v10H1z' />
      <path fill='#7fba00' d='M12 1h10v10H12z' />
      <path fill='#00a4ef' d='M1 12h10v10H1z' />
      <path fill='#ffb900' d='M12 12h10v10H12z' />
    </svg>
  );
}

/** Provider logo: bare by default, or boxed for the connect dialog. */
export function ProviderMark({
  provider,
  boxed = false,
  className,
}: {
  provider: string;
  boxed?: boolean;
  className?: string;
}) {
  const label = providerLabel(provider);
  const icon =
    label === 'Google Workspace' ? (
      <GoogleIcon className='h-4 w-4' />
    ) : label === 'LinkedIn' ? (
      // LinkedIn's brand blue reads on both themes.
      <AppIcon
        icon={iconLinkedin}
        className='text-[#0A66C2]'
        style={{ fontSize: 16 }}
        aria-hidden
      />
    ) : (
      <MicrosoftIcon className='h-4 w-4' />
    );
  if (!boxed)
    return <span className={cn('inline-flex', className)}>{icon}</span>;
  return (
    <span
      aria-hidden='true'
      className={cn(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border bg-background',
        className
      )}
    >
      {icon}
    </span>
  );
}
